import card from "../../../assets/img/projects/JppCompta/JppCompta.gif";


function App() {
  return (
    <div className="JppCompta img-footer">
        <img src={card} alt="" />
    </div>
  );
}

export default App;
